import {chooseRightAlertMessage} from './chooseRightAlertMessage';
import {chooseRightAlertMessageVariable} from './chooseRightAlertMessageVariable';
import {ChoseRightAlertMessageProps} from './types';

const buildAlertMessageProps = (
	props: ChoseRightAlertMessageProps,
): {message: string; variables: string[]} => {
	const message = chooseRightAlertMessage(props);
	const variable = chooseRightAlertMessageVariable(props);
	return {message, variables: [variable]};
};

export {buildAlertMessageProps};
